import script from "./AssetableModal.vue?vue&type=script&lang=js"
export * from "./AssetableModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/assets/AssetableModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef2940d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef2940d4', __exports__)) {
    console.log('reload')
    api.reload('ef2940d4', __exports__)
  }
  
}


export default __exports__